import React from "react";

/**
 * Reusable pipeline progress mini-bar.
 *   <PipelineBar invited={24} completed={15} scored={8} />
 *
 * Renders a stacked horizontal bar showing the funnel from `invited` →
 * `completed` → `scored`, plus a compact count summary. Falls back to a
 * grey placeholder when invited is 0.
 */
const PipelineBar = ({
  invited = 0,
  completed = 0,
  scored = 0,
  shortlisted = 0,
  height = 8,
  width,
  showLabels = true,
  className,
  style,
}) => {
  const total = Math.max(invited, completed + scored + shortlisted, 1);
  const pct = (n) => `${Math.min(100, Math.round((n / total) * 100))}%`;

  // Stacked widths derived from the funnel (each segment narrower than the previous)
  const segments = [
    { key: "scored",      n: scored,      color: "#10B981" },
    { key: "completed",   n: completed,   color: "#22C55E" },
    { key: "invited",     n: invited,     color: "#94A3B8" },
  ];
  const empty = invited === 0 && completed === 0 && scored === 0 && shortlisted === 0;

  return (
    <div className={className} style={{ display: "flex", flexDirection: "column", gap: 4, width, ...style }}>
      <div
        style={{
          position: "relative", height, borderRadius: height / 2,
          background: "rgba(148,163,184,0.18)", overflow: "hidden",
        }}
      >
        {!empty && segments.map((s) => (
          <div
            key={s.key}
            style={{
              position: "absolute", top: 0, left: 0, height: "100%",
              width: pct(s.n), background: s.color, borderRadius: height / 2,
              transition: "width 0.6s ease",
              zIndex: s.key === "scored" ? 3 : s.key === "completed" ? 2 : 1,
            }}
          />
        ))}
      </div>
      {showLabels && (
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "#64748B", lineHeight: 1.2 }}>
          <span><strong style={{ color: "#0F172A" }}>{invited}</strong> invited</span>
          <span><strong style={{ color: "#0F172A" }}>{completed}</strong> completed</span>
          <span style={{ color: "#10B981", fontWeight: 600 }}>{scored} scored</span>
          {shortlisted > 0 && <span style={{ color: "#16A34A", fontWeight: 600 }}>{shortlisted} shortlisted</span>}
        </div>
      )}
    </div>
  );
};

export default PipelineBar;
